import { gql } from '@apollo/client';

const GET_RETURNED_ORDER = gql`
  query getReturnedOrder($orderId: String, $email: String, $count: Int) {
    returnedOrder(orderId: $orderId, email: $email, count: $count) {
      orderDetails {
        email
        returnOrderDetails {
          labelUrl
          isCarrierScanned
          returnMethodPreference
          qrCodeRMANo
          returnOrderNumber
        }
        shippingAddress {
          country
          postalCode
        }
      }
      retNumber
      encodedOrderDetails
      returnDetailsURL
      returnMethod {
        type
        name
        showRETNumberOnConfirmation
        showMapLinkOnConfirmation
        eligibilityNoticeText
        mapUrl
        distributionCenterReturnAddress
        children {
          showDistributionAddress
          postalCode
          showDropoffLocations
          dropoffLocationsLink
          showMapLink
        }
        purolatorQRCodeServiceDetailsText
        purolatorSearchEligibleDropOffText
      }
      confirmationDetails {
        isShipMySelf
        showRETNumberOnConfirmation
        isQRCode
        canShowQRCode
        isLabel
        canShowLabel
        returnLabelTmnt
        errorMsgTmnt
        qrCodeRMANo
        retNumber
        hidePrintLabelBtn
        labelUrl
        isLabelUrlValid
        showQRCodeLabel
        printLabelLoadingTmnt
        printLabelReadyTmnt
        hasReturnAndNotExchange
        hasNotReturnAndHasExchange
        hasReturnAndHasExchange
        exchangeHeadlineTmnt
        refundMethodType
        qrCodeReturnDetailsTmnt
        qrCodeReturnDetailsMoreTmnt
        canShowRefundInitiatedDetails
        canShowEmailNotificationDetails
        canShowExchangeOrderShipDetails
        canShowReturnExchangeInitiatedDetails
        canShowReturnExchangeOrderShipDetails
        canShowItemDeliveredAndProcessedDetails
        canShowReturnInStoreRefundInitiatedDetailsOPM
        canShowReturnInStoreRefundInitiatedDetailsMC
        canShowDistributionCenterReturnAddress
        storeId
        catalogId
        langId
        orderHistoryUrl
        orderDetailUrl
        useReturnDetailsBtn
        isReadyToDisplay
        dropOffDate
        dropOffDateLong
        dropOffDateTmnt
        assetAvailable
      }
    }
  }
`;

export default GET_RETURNED_ORDER;